services.service('ProfileRulesHelper', [
    function () {


        // default profile rules
        var defaultRules = {
            firstName: {
                required: true,
                rawName: 'firstName',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            lastName: {
                required: true,
                rawName: 'lastName',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            birthday: {
                required: true,
                rawName: 'birthday',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            country: {
                required: true,
                rawName: 'country',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            state: {
                required: true,
                rawName: 'state',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            city: {
                required: true,
                rawName: 'city',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            address: {
                required: true,
                rawName: 'address',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            currency: {
                required: true,
                rawName: 'currency',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            customerType: {
                required: false,
                rawName: 'customerType',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            citizenship: {
                required: true,
                rawName: 'citizenship',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            postCode: {
                required: true,
                rawName: 'postCode',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            phone: {
                required: true,
                rawName: 'phone',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: true
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            isUSCitizen: {
                required: true,
                rawName: 'usCitizen',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            tin: {
                required: false,
                rawName: 'tin',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            taxCountry: {
                required: false,
                rawName: 'taxCountry',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            nationalId: {
                required: false,
                rawName: 'nationalId',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            companyName: {
                required: false,
                rawName: 'companyName',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            isMarried: {
                required: false,
                rawName: 'married',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            isSpouse: {
                required: false,
                rawName: 'spouseAware',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            birthPlace: {
                required: false,
                rawName: 'birthPlace',
                scopes: {
                    registration: {
                        hidden: false,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            tradingExperience: {
                required: false,
                rawName: 'tradingExperience',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            pep: {
                required: false,
                rawName: 'is_pep',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            tinAbsenceReason: {
                required: false,
                rawName: 'tin_absence_reason',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            gender: {
                required: false,
                rawName: 'gender',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: false
                    },
                    clientArea: {
                        hidden: true,
                        readonly: true,
                        readonlyIfNotEmpty: false
                    }
                }
            },
            terms: {
                required: false,
                rawName: 'terms',
                scopes: {
                    registration: {
                        hidden: true,
                        readonly: false,
                        readonlyIfNotEmpty: true
                    },
                    clientArea: {
                        hidden: true,
                        readonly: true,
                        readonlyIfNotEmpty: false
                    }
                }
            }
        };

        function ProfileRulesHelpder(_rules, scope) {
            var self = this;
            var rules = filterByScope(angular.merge(defaultRules, _rules), scope);

            this.get = function () {
                return rules;
            };

            function filterByScope(_rules, scope) {
                return Object.keys(_rules)
                    .reduce(function (acc, field) {
                        //constructing rule object with properties of then current scope
                        acc[field] = Object.assign({}, _rules[field], _rules[field].scopes[scope]);
                        return acc;
                    }, {})
            }

            this.isHidden = function (field) {
                return rules[field].hidden;
            };

            this.isVisible = function (field) {
                return !rules[field].hidden;
            };

            this.isReadonly = function (field, value) {
                if (!value) {
                    return rules[field].readonly;
                }

                return rules[field].readonly || (value && rules[field].readonlyIfNotEmpty);
            };

            this.isRequired = function (field) {
                return rules[field].required;
            };

            this.getRawName = function (field) {
                return rules[field].rawName;
            };

            /**
             * Returns profile rule by field raw name
             * @param rawName
             */
            this.getRuleByRawName = function (rawName) {
                var field = Object.keys(rules)
                    .find(function (field) {
                        return rules[field].rawName === rawName
                    });
                return field && rules[field]
            }
        }

        return ProfileRulesHelpder;

    }
]);
